export default __webpack_public_path__ + "56afdfe36ad5939b531ffe2989b99909.jpg";